import type {
  CustomBannerApi,
  CustomCtaApi,
  CustomCtaCreateRequestApi,
} from 'api-typings/common/common';
import { CustomCtaContextTypeApi } from 'api-typings/common/common';
import {
  transformRichTextElement,
  transformRichTextElementForApi,
} from '../content-customization/content-customization.transformers';
import type { CustomBanner, CustomCta } from './custom-banners.model';

export function transformCustomBanner(
  customBanner: CustomBannerApi,
): CustomBanner {
  return {
    id: customBanner.id,
    entityId: customBanner.entity_id,
    entityType: customBanner.entity_type,
    location: customBanner.location,
    textColor: customBanner.text_color,
    closeable: customBanner.closeable,
    dateCreated: customBanner.date_created * 1000,
    startDate: customBanner.start_date * 1000,
    endDate: customBanner.end_date && customBanner.end_date * 1000,
    title: customBanner.title,
    body: customBanner.body,
    backgroundImageUuid: customBanner.background_image_uuid,
    ctas: customBanner.ctas ? customBanner.ctas.map(transformCustomCta) : [],
  };
}

export function transformCustomCta(customCta: CustomCtaApi): CustomCta {
  return {
    id: customCta.id,
    contextId: customCta.context_id,
    contextType: customCta.context_type,
    ctaText: customCta.cta_text,
    ctaAction: customCta.cta_action,
    ctaLink: customCta.cta_link,
    modalTitle: customCta.modal_title,
    modalBody: customCta.modal_body
      ? customCta.modal_body.map(transformRichTextElement)
      : undefined,
  };
}

export function transformBannerCustomCtaForApi(
  cta: CustomCta,
): CustomCtaCreateRequestApi {
  return {
    /**
     * The datastore doesn't support nested computed fields. Custom fields has a similar problem when creating them on the projects collection.
     * Since they're nested on the custom banner object and only the backend knows what the new custom banner ID is, the frontend
     * has to pass -1 as a dummy value (which is ignored by the backend).
     */
    context_id: -1,
    context_type: CustomCtaContextTypeApi.BANNER,
    cta_text: cta.ctaText,
    cta_action: cta.ctaAction,
    cta_link: cta.ctaLink,
    modal_title: cta.modalTitle,
    modal_body:
      cta.modalBody && cta.modalBody.map(transformRichTextElementForApi),
  };
}
